export default {
  'searchQuestionnaire.list.button.newQuestionnaire': 'New Questionnaire',
  'searchQuestionnaire.list.description': 'Title',
  'searchQuestionnaire.list.numberOfQuestions': 'Number of Questions',
  'searchQuestionnaire.list.action': 'Action',

  'searchQuestionnaire.remove': 'Remove Quiz',
  'searchQuestionnaire.remove.alert':
    'Do you really want to remove the company:',
  'searchQuestionnaire.remove.notification.success': 'Success',
  'searchQuestionnaire.remove.notification.successDescription': 'Quiz removed',

  'searchQuestionnaire.questions.list.button.newQuestion': 'New Question',
  'searchQuestionnaire.questions.list.sequence': 'Sequence',
  'searchQuestionnaire.questions.list.description': 'Description',
  'searchQuestionnaire.questions.list.type': 'Type',
  'searchQuestionnaire.questions.list.type.MULTIPLE_CHOICE_SINGLE_ANSWER':
    'Single Answer',
  'searchQuestionnaire.questions.list.type.MULTIPLE_CHOICE_MULTIPLE_ANSWERS':
    'Multiple Answers',
  'searchQuestionnaire.questions.list.type.STARS_CLASSIFICATION':
    'Classification',
  'searchQuestionnaire.questions.list.type.COMMENTS_BOX': 'Comments',

  'searchQuestionnaire.replayDate.filter.startDate': 'Start Date',
  'searchQuestionnaire.replayDate.filter.endDate': 'End Date',
  'searchQuestionnaire.replayDate.filter.button': 'Filter',

  'searchQuestionnaire.replayDate.list.customer': 'Customer',
  'searchQuestionnaire.replayDate.list.responseDate': 'Response date',
  'searchQuestionnaire.replayDate.list.action': 'Action',
  'searchQuestionnaire.replayDate.list.see': 'See',

  'searchQuestionnaire.replayDate.modal.title': 'Customer questionnaire',
  'searchQuestionnaire.replayDate.modal.customer': 'Customer',
  'searchQuestionnaire.replayDate.modal.sendDate': 'Send date',

  'searchQuestionnaire.emptyDescription': 'No data to display',

  'searchQuestionnaire.syntheticAnalysis.comments.list.customer': 'Customer',
  'searchQuestionnaire.syntheticAnalysis.comments.list.answer': 'Answer',
};
